// FIXME make it a common lib for Client app - Admin - Portal
export const ALPHANUM_REGEX = /^([A-Z0-9]+)$/;
// src : https://www.w3resource.com/javascript/form/email-validation.php
export const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

export const ONE_DIGIT = /[0-9]/;
export const ONE_LOWERCASE = /[a-z]/;
export const ONE_UPPERCASE = /[A-Z]/;
